export function operacaoImpedimentosInRequest(params = {}) {
  return {
    type: '@operacaoimpedimentos/IMPEDIMENTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoImpedimentos(imab_codigo) {
  return {
    type: '@operacaoimpedimentos/FIND_IMPEDIMENTOS',
    payload: { imab_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoimpedimentos/FAILED_REQUEST',
  };
}

export function deleteOperacaoImpedimentos(imab_codigo, params) {
  return {
    type: '@operacaoimpedimentos/DELETE_IMPEDIMENTOS',
    payload: { imab_codigo, params },
  };
}

export function updateOperacaoImpedimentos(operacaoimpedimentos, params) {
  return {
    type: '@operacaoimpedimentos/UPDATE_IMPEDIMENTOS',
    payload: { operacaoimpedimentos, params },
  };
}

export function storeOperacaoImpedimentos(operacaoimpedimentos, params) {
  return {
    type: '@operacaoimpedimentos/STORE_IMPEDIMENTOS',
    payload: { operacaoimpedimentos, params },
  };
}

export function successInRequest(
  operacaoimpedimentos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoimpedimentos/SUCCESS_IN_REQUEST',
    payload: { operacaoimpedimentos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoimpedimentos) {
  return {
    type: '@operacaoimpedimentos/SUCCESS_REQUEST',
    payload: { operacaoimpedimentos },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoimpedimentos/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoimpedimentos/RECORD_FILTERING',
    payload: { params },
  };
}
